<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "nil_corr_in_cust_details"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#NilCorrCustomerDetail"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Nil Correction In Customer Detail</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="NilCorrCustomerDetail">
        <div class="risk row">
            <!--Institution Name starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.businessName.visibility && searchPartyData.partyType == 'O'">
                <div class="row form-group">
                    <float-label label="Institution Name*" :fixed="isFloat(nilCorrCustomerDetailData.businessName.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.businessName.value"
                            v-evolvews="nilCorrCustomerDetailData.businessName"
                            maxlength="240"
                            v-on:keydown="alphaNumericSpace"
                            :class="{ 'bgc-error-field': nilCorrCustomerDetailData.businessName.errorText!=='' }"
                            type="text"
                            class="form-control"
                            placeholder="Institution Name*"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.businessName.errorText !== ''">
                        {{nilCorrCustomerDetailData.businessName.errorText}}</span>
                </div>
            </div>
            <!--Institution Name ends-->
            <!--First Name* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.firstName.visibility && searchPartyData.partyType == 'I'">
                <div class="row form-group">
                    <float-label label="First Name*" :fixed="isFloat(nilCorrCustomerDetailData.firstName.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.firstName.value"
                            v-evolvews="nilCorrCustomerDetailData.firstName"
                            type="text"
                            maxlength="60"
                            v-on:keydown="onlyCharSpace"
                            :class="{'bgc-error-field':nilCorrCustomerDetailData.firstName.errorText !== ''}"
                            class="form-control"
                            placeholder="First Name*"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.firstName.errorText !== ''">
                        {{nilCorrCustomerDetailData.firstName.errorText}}</span>
                </div>
            </div>
            <!--First Name* ends-->
            <!--Middle Name starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.middleName.visibility && searchPartyData.partyType == 'I'">
                <div class="row form-group">
                    <float-label label="Middle Name" :fixed="isFloat(nilCorrCustomerDetailData.middleName.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.middleName.value"
                            v-evolvews="nilCorrCustomerDetailData.middleName"
                            type="text"
                            class="form-control"
                            maxlength="60"
                            v-on:keydown="onlyCharSpace"
                            placeholder="Middle Name"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.middleName.errorText !== ''">
                        {{nilCorrCustomerDetailData.middleName.errorText}}</span>
                </div>
            </div>
            <!--Middle Name ends-->
            <!--Last Name* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.lastName.visibility && searchPartyData.partyType == 'I'">
                <div class="row form-group">
                    <float-label label="Last Name*" :fixed="isFloat(nilCorrCustomerDetailData.lastName.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.lastName.value"
                            v-evolvews="nilCorrCustomerDetailData.lastName"
                            type="text"
                            :class="{'bgc-error-field':nilCorrCustomerDetailData.lastName.errorText !== ''}"
                            class="form-control"
                            placeholder="Last Name*"
                            maxlength="60"
                            v-on:keydown="onlyCharSpace"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.lastName.errorText !== ''">
                        {{nilCorrCustomerDetailData.lastName.errorText}}</span>
                </div>
            </div>
            <!--Last Name* ends-->
            <!--Primary Mobile No* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.mobileNo.visibility">
                <div class="row form-group">
                    <float-label label="Primary Mobile No*" :fixed="isFloat(nilCorrCustomerDetailData.mobileNo.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.mobileNo.value"
                            v-evolvews="nilCorrCustomerDetailData.mobileNo"
                            type="text"
                            v-on:keydown="onlyNumber"
                            @blur="checkValidationEmailAndMobile()"
                            @change="changeEncryptionValidation(nilCorrCustomerDetailData.mobileNo)"
                            maxlength="10"
                            :class="{'bgc-error-field':nilCorrCustomerDetailData.mobileNo.errorText !== ''}"
                            class="form-control"
                            placeholder="Primary Mobile No*"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.mobileNo.errorText !== ''">
                        {{nilCorrCustomerDetailData.mobileNo.errorText}}</span>
                </div>
            </div>
            <!--Primary Mobile No* ends-->
            <!--Primary Email Id* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.emailId.visibility">
                <div class="row form-group">
                    <float-label label="Primary Email Id*" :fixed="isFloat(nilCorrCustomerDetailData.emailId.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.emailId.value"
                            v-evolvews="nilCorrCustomerDetailData.emailId"
                            type="text"
                            @blur="checkValidationEmailAndMobile()"
                            @change="changeEncryptionValidation(nilCorrCustomerDetailData.emailId)"
                            :class="{'bgc-error-field':nilCorrCustomerDetailData.emailId.errorText !== ''}"
                            class="form-control"
                            placeholder="Primary Email Id*"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.emailId.errorText !== ''">
                        {{nilCorrCustomerDetailData.emailId.errorText}}</span>
                </div>
            </div>
            <!--Primary Email Id* ends-->
            <!--Secondary Mobile No starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.secondaryMobileNo.visibility">
                <div class="row form-group">
                    <float-label label="Secondary Mobile No" :fixed="isFloat(nilCorrCustomerDetailData.secondaryMobileNo.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.secondaryMobileNo.value"
                            v-evolvews="nilCorrCustomerDetailData.secondaryMobileNo"
                            type="text"
                            v-on:keydown="onlyNumber"
                            maxlength="10"
                            class="form-control"
                            placeholder="Secondary Mobile No"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.secondaryMobileNo.errorText !== ''">
                        {{nilCorrCustomerDetailData.secondaryMobileNo.errorText}}</span>
                </div>
            </div>
            <!--Secondary Mobile No ends-->
            <!--Secondary Email Id starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nilCorrCustomerDetailData.secondaryEmailId.visibility">
                <div class="row form-group">
                    <float-label label="Secondary Email Id" :fixed="isFloat(nilCorrCustomerDetailData.secondaryEmailId.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.secondaryEmailId.value"
                            v-evolvews="nilCorrCustomerDetailData.secondaryEmailId"
                            type="text"
                            class="form-control"
                            placeholder="Secondary Email Id"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.secondaryEmailId.errorText !== ''">
                        {{nilCorrCustomerDetailData.secondaryEmailId.errorText}}</span>
                </div>
            </div>
            <!--Secondary Email Id ends-->
            <!--Insured Address starts-->
            <!-- <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="row form-group">
                    <float-label label="Insured Address" :fixed="isFloat(nilCorrCustomerDetailData.insuredAddress.value)"> 
                        <input
                            v-model="nilCorrCustomerDetailData.insuredAddress.value"
                            v-evolvews="nilCorrCustomerDetailData.insuredAddress"
                            type="text"
                            class="form-control"
                            placeholder="Insured Address"
                            maxlength="240"
                        />
                    </float-label>
                    <span class="error-text" v-if="nilCorrCustomerDetailData.insuredAddress.errorText !== ''">
                        {{nilCorrCustomerDetailData.insuredAddress.errorText}}</span>
                </div>
            </div> -->
            <!--Insured Address ends-->
        </div>
    </div>
    <!--Correspondence Address start-->
    <div>
        <CorrespondenceAddress :selectedEndrsType="selectedEndrsType" :addressData="nilCorrCustomerDetailData" :areas="areas"  :permanentAreas="permanentAreas" v-if="nilCorrCustomerDetailData.correspondenceAddress.addressLine1.visibility"></CorrespondenceAddress>
    </div>
    <!--Permanent Address end-->
    </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import CorrespondenceAddress from "./CorrespondenceAddress.vue";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated, onMounted } from "@vue/composition-api";
export default {
  name: "NilCorrCustomerDetail",
  props: ["nilCorrCustomerDetailData",'searchPartyData','areas','permanentAreas','selectedEndrsType'],
  components: {
    CorrespondenceAddress,
    FloatLabel,
    Datepicker
  },
  setup(props, context) {
    let state = reactive({});
    // onMounted
    onMounted(()=>{
      if(props.searchPartyData.partyType == 'O'){
        context.root.$set(props.nilCorrCustomerDetailData.businessName,'stepsMandatory', true);
        delete props.nilCorrCustomerDetailData.businessName.skip;
        context.root.$set(props.nilCorrCustomerDetailData.firstName,'stepsMandatory', false);
        context.root.$set(props.nilCorrCustomerDetailData.lastName,'stepsMandatory', false);
        context.root.$set(props.nilCorrCustomerDetailData.firstName,'skip', true);
        context.root.$set(props.nilCorrCustomerDetailData.lastName,'skip', true);
      }
      else{
        context.root.$set(props.nilCorrCustomerDetailData.businessName,'stepsMandatory', false);
        context.root.$set(props.nilCorrCustomerDetailData.businessName,'skip', true);
        context.root.$set(props.nilCorrCustomerDetailData.firstName,'stepsMandatory', true);
        context.root.$set(props.nilCorrCustomerDetailData.lastName,'stepsMandatory', true);
        delete props.nilCorrCustomerDetailData.firstName.skip;
        delete props.nilCorrCustomerDetailData.lastName.skip;
      }
      context.parent.calculateSteps();
      if(props.nilCorrCustomerDetailData.mobileNo.visibility){
        context.parent.checkValidationEmailAndMobile();
      }
    })
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber = functions.onlyNumber;
    const onlyCharSpace = functions.onlyCharSpace;
    const onlyChar = functions.onlyChar;
    const addressOnly = functions.addressOnly;
    const alphaNumericSpace= functions.alphaNumericSpace;
    // const getLanguage= base.labelProcessor.get_labels();
    function updateAddressSteps(progressStep){
      context.parent.updateSteps(progressStep);
    }
    function calculateSteps(){
      context.parent.calculateSteps();
    }
    function onlyNumberMotor(e,targetObj){
      context.parent.onlyNumberMotor(e,targetObj);
    }
    function getAreaDetailsByPinCode(calledFrom){
      context.parent.getAreaDetailsByPinCode(calledFrom);
    }
    function enableCalculatePremiumBtn(endorsementType){
      context.parent.enableCalculatePremiumBtn(endorsementType);
    }
    function changeEncryptionValidation(obj){
      context.root.$set(obj,'skipEncryption',true);
    }
    function checkValidationEmailAndMobile(){
        context.parent.checkValidationEmailAndMobile()
    }
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.nilCorrCustomerDetailData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      context.parent.enableCalculatePremiumBtn('nilCorrCustomerDetail');
      context.parent.calculateSteps();
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyNumber,
      onlyChar,
      addressOnly,
      onlyCharSpace,
      alphaNumericSpace,
      onlyNumberMotor,
      updateAddressSteps,
      calculateSteps,
      getAreaDetailsByPinCode,
      enableCalculatePremiumBtn,
      changeEncryptionValidation,
      checkValidationEmailAndMobile
    //   getLanguage
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
.checkbox-inline {
  margin-top: 4px;
  margin-left: 15px;
}

@media (max-width: 767px) {
  .checkbox-inline {
    margin-top: 15px;
    position: relative;
    right: 12px;
    margin-left: 0px;
  }
}
@media (max-width: 575px) {
  .checkbox-inline {
    margin-top: 15px;
    position: relative;
    right: 27px;
  }
  .validate-pan-div {
    margin-top: 0px;
  }
  .add-wrapper {
    line-height: 20px;
    margin-left: 17px;
  }
  .blank-div {
    display: none;
  }
}
@media (max-width: 380px) {
  .checkbox-inline {
    margin-top: 0px;
    position: relative;
    right: 14px;
    display: flex;
  }
}

</style>
